export type WebLocationSample = {
  latitude: number;
  longitude: number;
  recordedAtMs: number;
  speed: number | null;
};

const EARTH_RADIUS_METRES = 6_371_000;

function toRadians(value: number) {
  return value * Math.PI / 180;
}

function distanceInMetres(previous: WebLocationSample, current: WebLocationSample) {
  const latitudeDelta = toRadians(current.latitude - previous.latitude);
  const longitudeDelta = toRadians(current.longitude - previous.longitude);
  const previousLatitude = toRadians(previous.latitude);
  const currentLatitude = toRadians(current.latitude);
  const haversine = Math.sin(latitudeDelta / 2) ** 2
    + Math.cos(previousLatitude) * Math.cos(currentLatitude) * Math.sin(longitudeDelta / 2) ** 2;
  return 2 * EARTH_RADIUS_METRES * Math.asin(Math.sqrt(haversine));
}

export function shouldRecordWebLocation(
  previous: WebLocationSample | null,
  current: WebLocationSample,
) {
  if (!previous) return true;
  const elapsedMs = Math.max(0, current.recordedAtMs - previous.recordedAtMs);
  const distanceMetres = distanceInMetres(previous, current);
  const speed = current.speed ?? 0;

  if (speed >= 15) return elapsedMs >= 10_000 || distanceMetres >= 50;
  if (speed >= 2) return elapsedMs >= 15_000 || distanceMetres >= 25;
  return elapsedMs >= 60_000 || distanceMetres >= 100;
}
